import Component from 'vue-class-component';
import Page from './Page';
import SigningSvg from '../common/SigningSvg';
import template from './Agreement.vue.html';

import { Method } from './app';

@Component({ template })
export default class Agreement extends Page {
    readonly svgViewBox = '0 0 800 600';

    requireSign() {
        return this.app.house?.agreement_method == Method.sign;
    }

    checkedAgreement: boolean = false;
    signatureSVG: string = '';
    drawing: boolean = false;
    private drawer?: SigningSvg;

    startSign() {
        if (!this.drawer)
            this.drawer = new SigningSvg(this.$refs.drawArea as SVGSVGElement);
        this.drawing = true;
    }

    decideSign() {
        let draw = this.drawer && this.drawer.dom;
        if (draw)
            this.signatureSVG = draw.outerHTML.includes('path')
                ? draw.outerHTML
                : '';
        console.info('Decide Sign', !!this.signatureSVG);
        this.drawing = false;
    }

    back() {
        this.app.setLang(null);
        this.app.setPage('Top');
    }

    async goNext() {
        if (this.requireSign()) {
            if (!this.signatureSVG) return alert(this._('require_signature'));
            const result = await this.app.post('agree', {
                sign: this.signatureSVG,
            });
            if (result.error)
                return alert(this._(result.error.message_code) || 'Error');
        } else {
            if (!this.checkedAgreement) return alert(this._('require_checked'));
            const result = await this.app.post('agree', {
                check: this.checkedAgreement,
            });
            if (result.error)
                return alert(this._(result.error.message_code) || 'Error');
        }

        const registeredAll = this.app.guestList.every((g) => g.completed);
        if (registeredAll) {
            this.app.setPage('Terminal');
            return;
        }
        this.app.setPage('Menu');
    }
}
